var path = 'src/app/patients/rituximab/baseline.html';
var html = "<h1 class=page-header>Baseline Clinical assessment</h1> <div rituximab-baseline-assessment-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/rituximab/baseline.html
 ** module id = 590
 ** module chunks = 0
 **/